/**
 * Component load more
 * 
 * @module component-load-more
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'component-load-more';

 if (!customElements.get(customElements.component)) {
 
     class componentLoadMore extends HTMLElement {
 
        constructor() {
 
             super();
 
             this.initEvents();
        }
 
        /**
         * Init Events
         * 
         * @return {undefined}
         */
        initEvents() {
            document.querySelectorAll("[data-loadmore-btn]").forEach(button => {
                button.addEventListener('click', event =>{
                    let grid =  document.querySelector("[data-loadmore-grid='"+ event.target.dataset.loadmoreBtn +"']");
                    this.loadMoreProducts(grid, event.target);
                });
            });
        }

        async  getNextPage(next_url) {
            try {
              let res = await fetch(next_url);
              return await res.text();
            } catch (error) {
              console.log(error);
            }
        }

        async  loadMoreProducts(grid, button) {
            let next_url = grid.dataset.nextUrl;

            button.innerHTML = 'Loading...';
            button.disabled = true;

            let nextPage = await this.getNextPage(next_url);
            
            const parser = new DOMParser();
            const nextPageDoc = parser.parseFromString(nextPage, 'text/html');            
            const productgrid = nextPageDoc.querySelector("[data-loadmore-grid='"+ button.dataset.loadmoreBtn +"']");
            const new_products = productgrid.querySelectorAll('[data-loadmore-item]');
            const new_url = productgrid.dataset.nextUrl;

            if (new_url) {
                button.disabled = false;
                button.innerHTML = 'Load More';
            }
            next_url = new_url;
            for (let i = 0; i < new_products.length; i++) {
                grid.appendChild(new_products[i]);
            }
        }
     }
 
     customElements.define(customElements.component, componentLoadMore);
}
